export const FIND_PROCESS_STATEMENT_QUESTIONS_SUCCESS = 'FIND_PROCESS_STATEMENT_QUESTIONS_SUCCESS';

export const findProcessStatementQuestionsSuccess = ({ questions }) => ({
    type: FIND_PROCESS_STATEMENT_QUESTIONS_SUCCESS,
    payload: { questions },
});
